import { useDropdownState } from '../abstract/dropdown';

export function useParkingFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: parking, onSelect: onParkingSelect, options: parkingOptions } = useDropdownState({
    defaultOptions: config.parkingOptions,
    defaultValue: query.parking || config.parkingDefault,
    filterKey: `parking`,
    setFilters,
    updateQuery,
  });

  return { parking, parkingOptions, onParkingSelect };
}
